/**
 * Months.
 * @type {array}
 */
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Menu items.
 * @type {object}
 */
export const MENU_ITEMS = {
  PERSONAL: 'personal',
  ASSETS: 'assets',
  BUSINESS: 'business',
  EXPENSES: 'expenses',
  QUALIFY: 'qualify',
  FILE: 'file',
};

/**
 * Payment periods.
 * @type {array}
 */
export const PAYMENT_PERIODS = [
  { code: 1, textValue: 'Monthly' },
  { code: 2, textValue: 'Weekly' },
  { code: 3, textValue: 'Biweekly' },
  { code: 4, textValue: 'Semi-Monthly' },
  { code: 5, textValue: 'Quarterly' },
];

/**
 * Types of residence.
 * @type {array}
 */
export const RESIDENCE_TYPES = [
  { code: 1, textValue: 'Single Family Home' },
  { code: 2, textValue: 'Vacation Property' },
  { code: 3, textValue: 'Timeshare' },
  { code: 4, textValue: 'MultiFamily Home' },
  { code: 5, textValue: 'Duplex' },
  { code: 6, textValue: 'Condominium' },
  { code: 7, textValue: 'Townhome' },
  { code: 8, textValue: 'Apartment' },
  { code: 9, textValue: 'Mobile Home' },
  { code: 10, textValue: 'Motorhome' },
  { code: 11, textValue: 'Land' },
  { code: 12, textValue: 'Other, for example Commercial Property' },
];

/**
 * Types of vehicle.
 * @type {array}
 */
export const VEHICLE_TYPES = [
  { code: 1, textValue: 'Car' },
  { code: 2, textValue: 'Truck' },
  { code: 3, textValue: 'Motorcycle' },
];

/**
 * Types of other assets.
 * @type {array}
 */
export const OTHER_ASSET_TYPES = [
  { code: 1, textValue: 'Car' },
  { code: 2, textValue: 'Boat' },
  { code: 3, textValue: 'Recreational Vehicle' },
  { code: 4, textValue: 'Whole Life Policy' },
  { code: 5, textValue: 'Truck' },
  { code: 6, textValue: 'Motorcycle' },
];

export const CARD_TYPES = [
  { value: '1', text: 'Amex, Discover, Master Card, Visa' },
  { value: '2', text: 'Other' },
];

/**
 * Types of credit accounts.
 * @type {array}
 */
export const CREDIT_ACCOUNT_TYPES = [
  { code: 1, textValue: 'Checking' },
  { code: 2, textValue: 'Savings' },
  { code: 3, textValue: 'Mobile' },
  { code: 4, textValue: 'Money Market' },
];

/**
 * Types of investment accounts.
 * @type {array}
 */
export const INVESTMENT_ACCOUNT_TYPES = [
  { code: 1, textValue: 'Certificates of Deposit' },
  { code: 2, textValue: 'Trusts' },
  { code: 3, textValue: 'Individual Retirement Accounts' },
  { code: 4, textValue: 'Keogh Plans' },
  { code: 5, textValue: 'Simplified Employee Pensions' },
  { code: 6, textValue: 'Plans 401' },
  { code: 7, textValue: 'Profit Sharing Plans' },
  { code: 8, textValue: 'Mutual Funds' },
  { code: 9, textValue: 'Stocks' },
  { code: 10, textValue: 'Bonds' },
  { code: 11, textValue: 'Commodities' },
  { code: 12, textValue: 'Other Investments' },
  { code: 13, textValue: 'Business Accounts' },
];

/**
 * Types of virtual currency.
 * @type {array}
 */
export const VIRTUAL_CURRENCY_TYPES = [
  { code: 1, textValue: 'Bitcoin' },
  { code: 2, textValue: 'Ethereum' },
  { code: 3, textValue: 'Litecoin' },
  { code: 4, textValue: 'Ripple' },
  { code: 5, textValue: 'Others' },
];

/**
 * Locations of virtual currency.
 * @type {array}
 */
export const VIRTUAL_CURRENCY_LOCATIONS = [
  { code: 1, textValue: 'Mobile Wallet' },
  { code: 2, textValue: 'Online' },
  { code: 3, textValue: 'External Hardware Storage' },
];

/**
 * Finance verified statuses.
 * @type {object}
 */
export const FINANCE_VERIFIED_STATUS = {
  CNC: 0,
  GUARANTEED: 1,
  PARTIAL_PAY: 2,
  STREAMLINE72: 3,
  STREAMLINE84: 4,
  ELECTRONIC_FILING_DISABLED: 5,
};

/**
 * Access types.
 * @type {array}
 */
export const ACCESS_TYPES = [
  { code: 0, textValue: 'None' },
  { code: 1, textValue: 'Application Access Individual' },
  { code: 2, textValue: 'Application Access Business' },
  { code: 5, textValue: 'CertifiedPublicAccountant' },
];

/**
 * User access types.
 * @type {object}
 */
export const USER_ACCESS_TYPES = {
  Individual: 1,
  Business: 2,
};

/**
 * Filing types.
 * @type {object}
 */
export const FILING_TYPES = {
  EZTX: 0,
  MANUAL: 1,
};

/**
 * Grant access types.
 * @type {object}
 */
export const GRANT_ACCESS_TYPES = {
  INDIVIDUAL: 1,
  BUSINESS: 2,
  EZTX_SOLUTION: 3,
  COACHING: 4,
};

/**
 * Marital statuses.
 * @type {array}
 */
export const MARITAL_STATUSES = [
  { code: 1, textValue: 'Single' },
  { code: 2, textValue: 'Married filing joint tax returns' },
  { code: 3, textValue: 'Married filing separate tax returns' },
];

/**
 * Agent roles.
 * @type {array}
 */
export const AGENT_ROLES = [
  { code: 0, textValue: 'Admin' },
  { code: 1, textValue: 'Coach' },
  { code: 2, textValue: 'Negotiator' },
];


/**
 * Loading statuses.
 * @type {object}
 */
export const LOADING_STATUSES = {
  SUCCESS: 'success',
  ERROR: 'error',
};

/**
 * Clients' resolutions.
 * @type {array}
 */
export const RESOLUTIONS = [
  { code: 'Streamline72', textValue: 'Streamlined 72' },
  { code: 'Streamline84', textValue: 'Streamlined 84' },
  { code: 'Cnc', textValue: 'CNC' },
  { code: 'FinanciallyVerified', textValue: 'Financially Verified' },
  { code: 'PartialPay', textValue: 'Partial Pay' },
  { code: 'Guaranteed', textValue: 'Guaranteed Installment Agreement' },
  { code: 'ElectronicFilingDisabled', textValue: 'Electronic Filing Disabled' },
  { code: '', textValue: '-' },
];

/**
 * Security question types.
 * @type {object}
   */
export const QUESTION_TYPES = {
  USER_TYPE: 0,
  ADMIN_TYPE: 1,
};

/**
 * User roles.
 * @type {object}
 */
export const ROLES = {
  COACH: 'Coach',
  ADMIN: 'Admin',
  NEGOTIATOR: 'Negotiator',
  CPA: 'CertifiedPublicAccountant',
  SUPER_ADMIN: 'SuperAdmin',
};

/**
 * CPA's app access type.
 * @type {number}
 */
export const DEFAULT_CPA_APP_ID = 5;

/**
 * User app access type.
 * @type {number}
 */
export const DEFAULT_REGULAR_USER_APP_ID = 1;
